module.exports = __webpack_public_path__ + "img/panelView_strong_Bg_1_3.60a68fd7.png";